const {
    showWorkingDialog,
    updateWorkingDialog,
    hideWorkingDialog,
} = require("./dialogs");
const _ = require("underscore");
const { postMultipartFormAjax } = require("./shared");
const { showFlash } = require("./ui_utils");

const uploadImage = (inputEl, resizeOptions, url, data, successFn) => {
    if (isActionBlocked()) return;
    if (!inputEl.get(0).files.length) return;

    const dialog = showWorkingDialog("Reading image");

    const inputFile = inputEl.get(0).files[0];
    const formData = new FormData();

    if (data) {
        _.each(_.keys(data), function (key) {
            formData.append(key, data[key]);
        });
    }

    const resizeImageInCanvasCallback = (dataURL) => {
        updateWorkingDialog(dialog, "Uploading image");

        const blob = dataURItoBlob(dataURL);
        formData.append("image", blob);
        postMultipartFormAjax(
            url,
            formData,
            function (result) {
                hideWorkingDialog(dialog);
                if (result.success) {
                    successFn(result.url || result);
                } else {
                    showFlash("error", result.message);
                }
            },
            function (error) {
                showFlash("error", error);
            }
        );
    };

    const exifOrientationCallback = () =>
        resizeImageInCanvas(
            inputFile,
            resizeOptions,
            resizeImageInCanvasCallback
        );

    // get image orientation
    getImageOrientationFromEXIF(inputFile, exifOrientationCallback);
};

const getImageOrientationFromEXIF = (inputFile, callback) => {
    // https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side

    const reader = new FileReader();
    reader.onload = function (e) {
        const view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xffd8) return callback(-2);
        let length = view.byteLength,
            offset = 2;
        while (offset < length) {
            const marker = view.getUint16(offset, false);
            offset += 2;
            if (marker == 0xffe1) {
                if (view.getUint32((offset += 2), false) != 0x45786966)
                    return callback(-1);
                const little = view.getUint16((offset += 6), false) == 0x4949;
                offset += view.getUint32(offset + 4, little);
                const tags = view.getUint16(offset, little);
                offset += 2;
                for (let i = 0; i < tags; i++)
                    if (view.getUint16(offset + i * 12, little) == 0x0112)
                        return callback(
                            view.getUint16(offset + i * 12 + 8, little)
                        );
            } else if ((marker & 0xff00) != 0xff00) break;
            else offset += view.getUint16(offset, false);
        }
        return callback();
    };

    reader.readAsArrayBuffer(inputFile);
};

function resizeImageInCanvas(file, resizeOptions, callback) {
    const targetWidth = resizeOptions.targetWidth || 360;
    const targetHeight = resizeOptions.targetHeight || 360;
    const mimeType = resizeOptions.mimeType || "image/jpeg";
    const quality = resizeOptions.quality || 0.8;

    // create a hidden img
    const img = document.createElement("img");
    img.style.display = "none";
    document.body.appendChild(img);

    const reader = new FileReader();

    // callback when file is completed reading...
    reader.onload = function (e) {
        // callback when img source is loaded...
        img.onload = function () {
            // create a canvas to work on...
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            // calculate which direction to scale, width or height
            const srcWidth = img.width;
            const srcHeight = img.height;

            const hRatio = targetWidth / srcWidth;
            const vRatio = targetHeight / srcHeight;
            const ratio = Math.max(hRatio, vRatio);
            const offsetX = (targetWidth - srcWidth * ratio) / 2;
            const offsetY = (targetHeight - srcHeight * ratio) / 2;

            canvas.width = targetWidth;
            canvas.height = targetHeight;
            ctx.drawImage(
                img,
                0,
                0,
                srcWidth,
                srcHeight,
                offsetX,
                offsetY,
                srcWidth * ratio,
                srcHeight * ratio
            );

            callback(canvas.toDataURL(mimeType, quality));
        };

        // set the image's source to the file we read...
        img.src = e.target.result;
    };

    // read in the file...
    reader.readAsDataURL(file);
}

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
}

// VIDEO
function showYouTube(videoId, title, successBtn) {
    // create modal
    const modalEl = $('<div class="modal fade">');
    modalEl.append(
        $('<div class="modal-dialog modal-lg">').append(
            $('<div class="modal-content">')
                .append(
                    $('<div class="modal-header">').append(
                        $("<h4>").text(title)
                    )
                )
                .append($('<div class="modal-body text-center">'))
                .append(
                    $('<div class="modal-footer">')
                        .append(
                            $(
                                '<button type="button" class="btn btn-default" data-dismiss="modal">'
                            ).text("Close")
                        )
                        .append(
                            $(
                                '<button type="button" class="btn btn-primary" data-dismiss="modal">'
                            ).text(successBtn)
                        )
                )
        )
    );

    const bodyEl = $(".modal-body", modalEl);

    // you tube player
    const youtubeContainerEl = $(
        '<div id="player-container" class="video-container">'
    );
    const youtubePlayerEl = $('<div id="youtube-player">');
    youtubeContainerEl.append(youtubePlayerEl);
    bodyEl.append(youtubeContainerEl);
    const player = new YT.Player(youtubePlayerEl.get(0), {
        videoId: videoId,
        playerVars: {
            autohide: 1,
            autoplay: 1,
            controls: 1,
            rel: 0,
            showinfo: 0,
        },
        events: {
            onReady: function (event) {
                modalEl.modal("show");
            },
            onStateChange: function (event) {
                if (event.data == YT.PlayerState.ENDED) {
                    modalEl.modal("hide");
                }
            },
            onError: null,
        },
    });

    modalEl
        .on("shown.bs.modal", function (event) {
            player.playVideo();
        })
        .on("hide.bs.modal", function (event) {
            player.stopVideo();
        })
        .on("hidden.bs.modal", function (event) {
            modalEl.remove();
        });

    $("body").append(modalEl);
}

const getVideoDimensions = (file) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        const objectUrl = URL.createObjectURL(file);

        video.preload = "metadata";
        video.src = objectUrl;
        video.muted = true;
        video.playsInline = true;

        video.onloadedmetadata = function () {
            const width = video.videoWidth;
            const height = video.videoHeight;
            URL.revokeObjectURL(objectUrl);
            resolve({ width, height });
        };

        video.onerror = function () {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("Unable to read video metadata."));
        };
    });
};

const validateVideo = async (file) => {
    if (!file) {
        throw new Error("No video file provided.");
    }

    if (file.type !== "video/mp4") {
        throw new Error("Only MP4 video files are allowed.");
    }

    const { width, height } = await getVideoDimensions(file);
    console.log(`Video dimensions: ${width}x${height}`);
    const expectedRatio = 9 / 16;
    const actualRatio = width / height;
    const tolerance = 0.01;

    if (Math.abs(actualRatio - expectedRatio) > tolerance) {
        throw new Error(
            "Video resolution should be 2160 × 3840 pixels. This corresponds to a vertical (portrait) 9:16 aspect ratio."
        );
    }

    return { width, height };
};

const uploadVideo = async (inputEl, url, data, successFn) => {
    if (!inputEl.get(0).files.length) return;

    const dialog = showWorkingDialog("Reading video");

    try {
        const inputFile = inputEl.get(0).files[0];
        const formData = new FormData();

        if (data) {
            _.each(_.keys(data), function (key) {
                formData.append(key, data[key]);
            });
        }

        await validateVideo(inputFile);

        updateWorkingDialog(dialog, "Uploading video");

        formData.append("video", inputFile);

        postMultipartFormAjax(
            url,
            formData,
            function (result) {
                hideWorkingDialog(dialog);
                if (result.success) {
                    successFn(result.url || result);
                } else {
                    showFlash("error", result.message || result.error);
                }
            },
            function (error) {
                hideWorkingDialog(dialog);
                showFlash("error", error);
            }
        );
    } catch (error) {
        hideWorkingDialog(dialog);
        showFlash("error", error.message || "Unable to process video.");
    }
};
module.exports = {
    uploadImage,
    showYouTube,
    getImageOrientationFromEXIF,
    resizeImageInCanvas,
    dataURItoBlob,
    uploadVideo,
    getVideoDimensions,
};
